/* Conditional validation for EEVA's existing Klaviyo popup and footer forms.
   Klaviyo remains responsible for collecting properties and consent. */
(() => {
  'use strict';
  const forms = ['WaW9RA', 'YgVFeT'];
  const selector = forms.map(id => `form[data-testid="klaviyo-form-${id}"]`).join(',');
  const watched = new WeakSet();
  let queued = false;
  const parts = form => {
    const model = form.querySelector('input[role="combobox"][placeholder="Select your model (optional)"]');
    const detail = form.querySelector('input[id^="BYD_Model_Other_"]');
    const block = detail?.closest('[data-testid="form-component"]');
    return model && detail && block ? { model, detail, block } : null;
  };
  const clear = input => {
    if (!input.value) return;
    const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, '');
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const sync = form => {
    const p = parts(form);
    if (!p) return null;
    const other = p.model.value.trim() === 'Other BYD model';
    p.block.classList.toggle('eeva-model-other-hidden', !other);
    p.detail.required = other;
    p.detail.setAttribute('aria-required', String(other));
    if (!other) clear(p.detail);
    if (!other || p.detail.value.trim()) {
      p.detail.setCustomValidity('');
      if (p.detail.dataset.eevaInvalid) {
        p.detail.setAttribute('aria-invalid', 'false');
        delete p.detail.dataset.eevaInvalid;
      }
    }
    return { ...p, other };
  };
  const refresh = () => {
    queued = false;
    document.querySelectorAll(selector).forEach(form => {
      if (!watched.has(form)) {
        watched.add(form);
        new MutationObserver(schedule).observe(form, { attributes: true, subtree: true, attributeFilter: ['value'] });
      }
      sync(form);
    });
  };
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(refresh); }
  }
  const formFor = target => target instanceof Element ? target.closest(selector) : null;
  const validate = (event, form) => {
    const p = sync(form);
    if (!p?.other || p.detail.value.trim()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const label = p.detail.labels?.[0]?.textContent?.trim() || p.detail.placeholder;
    p.detail.setCustomValidity(label);
    p.detail.setAttribute('aria-invalid', 'true');
    p.detail.dataset.eevaInvalid = 'true';
    p.detail.focus();
    p.detail.reportValidity();
  };
  document.addEventListener('click', event => {
    const form = formFor(event.target);
    if (!form) return;
    const button = event.target.closest('button');
    // Klaviyo regenerates action IDs when publishing. Match the existing
    // signup CTA in these two forms, leaving dropdown and dismissal alone.
    if (button?.matches('button[data-action-id]') && button.textContent.trim().toLowerCase() === 'get my 5% off') validate(event, form);
    schedule();
  }, true);
  document.addEventListener('submit', event => {
    const form = formFor(event.target);
    if (form) validate(event, form);
  }, true);
  document.addEventListener('keydown', event => {
    const form = formFor(event.target);
    // Let Enter choose an open dropdown option; validate Enter that submits.
    if (form && event.key === 'Enter' && event.target.getAttribute('aria-expanded') !== 'true' && event.target.tagName === 'INPUT') validate(event, form);
  }, true);
  ['input', 'change', 'keyup'].forEach(type => document.addEventListener(type, event => {
    const form = formFor(event.target);
    if (form) { sync(form); schedule(); }
  }, true));
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  refresh();
})();
